import React, { Component } from "react";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Banner from "../../components/Banner";
import Summary from "../../components/Summary";
import Video from "../../components/Video"
import PageHelmet from "../../components/Helmet";

function FilmPage(props) {
    return class PortfolioDetails extends Component {
        constructor () {
            super()
            this.state = {
              isOpen: false
            }
            this.openModal = this.openModal.bind(this)
        }
        openModal () {
            this.setState({isOpen: true})
        }
        render(){
            return(
                <React.Fragment>
                    
                    <PageHelmet pageTitle='Portfolio Details' />

                    <Header logo="symbol-dark" color="color-black"/>
                    
                    <Banner title={props.title} type={props.type} bg={props.bg} />

                    <Summary summary={props.summary} type={props.type} title={props.title}/>
                    
                    <Video videoImage={props.videoImage} videoId={props.videoId} channel={props.channel} />

                    {/* Start Back To Top */}
                    <div className="backto-top">
                        <ScrollToTop showUnder={160}>
                            <FiChevronUp />
                        </ScrollToTop>
                    </div>
                    {/* End Back To Top */}
                    
                    <Footer />  


                </React.Fragment>
            )
        }
    }
}

export default FilmPage;
